module.exports = __webpack_public_path__ + "img/20f6.9a7eb416.jpg";